<template>
	<section class="deal-checklist-visit-link stretch-to-fit">
		<h1>{{ checklistItem.name }}</h1>
		<p>{{ checklistItem.description }}</p>

		<a
			:href="reviewLink"
			target="_blank"
		>
			<qrcode-vue
				class="qr-code-container"
				:size="250"
				:value="reviewLink"
				level="H"
				:background="cssBackgroundColor"
				:foreground="cssForegroundColor"
			/>
		</a>
	</section>
</template>
<script>
	import DealChecklistItem from '@core/classes/Checklist/DealChecklistItem';
	import QrcodeVue from 'qrcode.vue';

	export default {
		name: 'CustomerChecklistVisitLink',
		props: {
			checklistItem: DealChecklistItem,
		},
		data() {
			return {};
		},
		computed: {
			reviewLink() {
				return this.checklistItem.getMetadataValue('getLinkExpression');
			},
			validateClick() {
				return this.checklistItem.getMetadataValue('validateWhenClicked') === 'true' || false;
			},
			cssBackgroundColor() {
				const customerPage = document.querySelector('.customer-checklist-page');
				if (!customerPage) return '#FFF';

				return window.getComputedStyle(customerPage)?.getPropertyValue('--main-color') ?? '#FFF';
			},
			cssForegroundColor() {
				const customerPage = document.querySelector('.customer-checklist-page');
				if (!customerPage) return '#000';

				return window.getComputedStyle(customerPage)?.getPropertyValue('--alt-text-color') ?? '#000';
			},
		},
		methods: {},
		components: {
			QrcodeVue,
		},
	};
</script>
<style>
	.deal-checklist-visit-link a {
		margin: auto 10px;
		padding: 20px;
		text-align: center;
	}

	.deal-checklist-visit-link a .qr-code-container canvas {
		height: unset !important;
		width: 80% !important;
		border-radius: 10px;
	}

	@media (max-width: 800px) {
		.deal-checklist-visit-link a {
			padding: unset;
		}
	}
</style>
